import { render } from "./PendingCasesList.vue?vue&type=template&id=875870a0"
import script from "./PendingCasesList.vue?vue&type=script&lang=js"
export * from "./PendingCasesList.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/cases/PendingCasesList.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "875870a0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('875870a0', __exports__)) {
    console.log('reload')
    api.reload('875870a0', __exports__)
  }
  
  module.hot.accept("./PendingCasesList.vue?vue&type=template&id=875870a0", () => {
    console.log('re-render')
    api.rerender('875870a0', render)
  })

}


export default __exports__